import React from "react";
import Button from "./form/Button";

const WelcomeModal = ({ 
  isOpen, 
  onClose, 
  onProceed, 
  message = "Please make sure you have S4S blank sim before proceed",
  cancelText = "No",
  proceedText = "Proceed",
  proceedDisabled = false,
  busy = false,
  statusMessage = "",
  reference = ""
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-[24px] p-8 max-w-md mx-4 text-center">
        <p className="text-gray text-[15px] mb-6">
          {message}
        </p>
        {statusMessage && <p role="status" className="text-gray text-[13px] mb-4">{statusMessage}</p>}
        {reference && (
          <p className="text-gray text-[13px] mb-4 break-all">
            Reference sent: <span className="font-mono select-all">{reference}</span>
          </p>
        )}
        <div className="grid grid-cols-2 gap-4">
          <Button
            eventAction={onClose}
            disable={busy}
            children={cancelText}
            classes={"text-primary border border-primary bg-white"}
            roundness={"pill"}
            type={"button"}
            size={"costum"}
            intent={"more"}
          />
          <Button
            eventAction={onProceed}
            type="button"
            disable={proceedDisabled || busy}
            classes="disabled:opacity-50 disabled:cursor-not-allowed"
            children={proceedText}
            intent={"primary"}
            size={"md"}
            roundness={"round"}
          />
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
